import * as _ from 'underscore';
import { IKeyValue, IEditObject, IInitialValue } from '../interfaces';
import { ID } from '../const';

export class EditObject {
	private _properties: IKeyValue<KnockoutObservable<any>>;
	private propertyMeta: IEditObject<string>[];
	private obj: any;
	private copyObj: any;
	private errors: KnockoutValidationErrors;
	public get Properties(): IKeyValue<KnockoutObservable<any>> {
		return this._properties;
	}
	constructor(obj: any, meta: IEditObject<string>[]) {
		this._properties = {};
		this.propertyMeta = meta;
		this.obj = obj;
		this.copyObj = {};
		this.errors = null;
		this.init();
	}
	private init() {
		//TODO: set focus on first editable property
		var focus = true;
		for (var meta of this.propertyMeta) {
			if (this.obj[meta.key] !== undefined) {
				this.copyObj[meta.key] = this.obj[meta.key];
				if (meta.isEditable) {
					var obs = ko.observable(this.obj[meta.key]);
					if (meta.rules && meta.rules.length > 0) {
						meta.rules.forEach(rule => {
							if (EditObject.isObjectParams(rule.params)) {
								rule.params.initialValue = this.obj[meta.key];
							}
							ko.validation.addRule(obs, rule);
						});
					}
					this._properties[meta.key] = obs;
					this._properties[meta.key.concat(ID.HasFocus)] = ko.observable<boolean>(focus);
					if (focus) {
						focus = false;
					}
				} else {
					this._properties[meta.key] = this.obj[meta.key];
				}
			}
		}
		this.errors = ko.validation.group(this, { deep: true, live: true });
	}
	public sync() {
		for (var key of this.propertyMeta) {
			if (this.obj[key.key] !== undefined && this._properties[key.key] !== undefined) {
				this.obj[key.key] = ko.unwrap(this._properties[key.key]);
			}
		}
	}
	public cancel() {
		for (var meta of this.propertyMeta) {
			if (this.obj[meta.key] !== undefined) {
				this.obj[meta.key] = this.copyObj[meta.key];
			}
		}
	}
	public validate(force: boolean = false): boolean {
		if (force) {
			for (var propertyKey in this.Properties) {
				this.Properties[propertyKey].valueHasMutated();
			}
		}
		var isValid = true;
		if (this.errors().length > 0) {
			isValid = false;
			this.errors.showAllMessages(true);
		}
		return isValid;
	}
	public hideValidationMessages() {
		this.errors.showAllMessages(false);
	}
	public static isObjectParams(params: any): params is IInitialValue<any> {
		return _.isObject(params);
	}
}
